// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { alliedUniversityNavigationContainerStyles } from "@awc/App/Widgets/AlliedUniversitySideNavigation/AlliedUniversityNavigationContainer";
import { color } from "@awc/XDL/Utilities";
import { css } from "styled-components";

alliedUniversityNavigationContainerStyles.container = {
    css: css`
        box-shadow: 0 0 2px 1px ${color("common.ui7", 0.4)};
        border-top: 4px solid ${color("common.ui14")};
        padding: 16px;
    `,
};
